import { locale, updateLocaleOptions } from "primereact/api";
import { useEffect, useRef } from "react";
import { useLocStore } from ".";
import { LocContext } from "./LocContext";
import { getTranslationMap } from "./getTranslationMap";
import { CvpLocale } from "../constants/CvpLocale";
import { getSourceMap } from "./getSourceMap";

export const usePrimeLocale = () => {
  const L = useLocStore(LocContext.GENERAL);

  const lastSetLocale = useRef<CvpLocale>(null);

  const setPrimeLocale = async () => {
    let localeToLoad: CvpLocale;

    if (L.gotTranslationsForLocale) {
      localeToLoad = L.gotTranslationsForLocale;
    }

    if (localeToLoad && localeToLoad !== lastSetLocale.current) {
      const options =
        localeToLoad === CvpLocale.nb
          ? await getSourceMap(LocContext.PRIME, localeToLoad)
          : await getTranslationMap(LocContext.PRIME, localeToLoad);

      updateLocaleOptions(options, "_custom_primelocale_");

      locale("_custom_primelocale_");
      lastSetLocale.current = localeToLoad;
    }
  };

  useEffect(() => {
    setPrimeLocale();
  }, [L.gotTranslationsForLocale]);
};
